import { render, staticRenderFns } from "./transformView.vue?vue&type=template&id=3de10ca8&scoped=true"
import script from "./transformView.vue?vue&type=script&lang=js"
export * from "./transformView.vue?vue&type=script&lang=js"
import style0 from "./transformView.vue?vue&type=style&index=0&id=3de10ca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de10ca8",
  null
  
)

export default component.exports